import { render, staticRenderFns } from "./NsProductCard.vue?vue&type=template&id=291c7926&"
import script from "./NsProductCard.vue?vue&type=script&lang=js&"
export * from "./NsProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports